import { render, staticRenderFns } from "./WeeklyEmailTodoList.vue?vue&type=template&id=baedf53c&"
import script from "./WeeklyEmailTodoList.vue?vue&type=script&lang=js&"
export * from "./WeeklyEmailTodoList.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyEmailTodoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports